
import Vue from 'vue'

export default Vue.extend({
   name: 'TargetTypes',
   props: {
      value: Array as () => Array<{ Name: string; ColourClass: string }>,
   },
   computed: {
      showIcon(): boolean {
         return this.value.length > 0
      },
   },
})
